import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Field, Form, Formik } from 'formik'
import Section from '../../common/components/layout/Section'
import SectionHeader from '../../common/components/layout/SectionHeader'
import { updateApplicationSettings } from '../../common/redux/settings/settings-actions'

import NumberInput from '../../common/components/NumberInput'
import Button from '../../common/components/Button'

import './LayoutStyle.scss'

class LayoutStyle extends Component {

  constructor (props) {
    super(props)
    this.state = {
      expanded: false,
    }
  }

  /*
            <Manager>
            <div className={'info-image-popper-icon'}>
              <Reference>
                {({ ref }) => (
                  <div ref={ref} className={'info-expandable'}>
                    <IconButton className={'expand-button'} icon={'info'} onClick={() => this.handleExpandButtonClicked()}/>
                  </div>
                )}
              </Reference>
              {this.state.expanded &&
              <Popper placement="bottom-start">
                {({ ref, style, placement }) => (
                  <div ref={ref} style={{ ...style, zIndex: 3 }} data-placement={placement}>
                    <SpacingInfoImage onClose={() => this.handleExpandButtonClicked()}/>
                  </div>
                )}
              </Popper>}
            </div>
          </Manager>
   */

  render () {

    return (

      <Section className="layout-styles">
        <SectionHeader className={'layout-style-header'} title={'Layout Styles'}>

        </SectionHeader>

        <Formik initialValues={{ ...this.props.settings }}
                onSubmit={(values) => this.handleSettingChanges(values)}
                enableReinitialize>
          <Form className={'layout-style-form'}>
            <Field name={'corridorWidth'} component={NumberInput} label={'Corridor width'} step={0.1}/>
            <Field name={'doubleCorridorDepth'} component={NumberInput} label={'Double Corridor Depth'} step={0.1}/>

            <div className={'layout-style-border'}/>

            <div className={'layout-style-form-buttons'}>
              <Button type="reset">Discard</Button>
              <Button type="submit" variant={'contained'}>Confirm</Button>
            </div>

          </Form>
        </Formik>

      </Section>
    )
  }

  handleExpandButtonClicked () {
    this.setState({ expanded: !this.state.expanded })
  }

  handleSettingChanges (values) {
    this.props.updateApplicationSettings(values)
  }
}

let mapStateToProps = (state) => {
  return {
    settings: state.settings.appSettings,
  }
}

let mapDispatchToProps = {
  updateApplicationSettings: updateApplicationSettings,
}

export default connect(mapStateToProps, mapDispatchToProps)(LayoutStyle)